import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-sm">
                A
              </div>
              <span className="font-heading font-semibold text-base text-background-50">
                Akiho Fans
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              吉泽明步粉丝资讯站，致力于为粉丝提供最全面、最权威的吉泽明步相关信息。
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all duration-200" aria-label="Twitter">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all duration-200" aria-label="Instagram">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all duration-200" aria-label="YouTube">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">内容分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/category/news" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">最新动态</Link></li>
              <li><Link to="/category/community" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">粉丝社区</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">联系方式</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line mt-0.5"></i>
                <span>contact@akihofans.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>日本东京都</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2026 Akiho Fans. 本站为粉丝自发创建的资讯站，与官方无直接关联。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}